export default {
  computed: {
    /**
     * Deteremine if location is editable.
     *
     * @return boolean
     */
    locationIsEditable () {
      if (this.$user.isAdminOrCoordinator) {
        return true
      }

      if (this.$user.isDisabled) {
        return false
      }

      if (this.location.user_id === this.$user.parent_id) {
        return true
      }

      return this.location.user_id === this.$user.id || this.location.id === null
    },

    /**
     * Determine if location is not editable.
     *
     * @return boolean
     */
    locationNotEditable () {
      return !this.locationIsEditable
    },

    /**
     * Determine if the location has a lat and lng.
     *
     * @return boolean
     */
    locationHasLatitudeAndLongitude () {
      return this.latitude !== null && this.longitude !== null
    },

    /**
     * Determine if location has a photo.
     *
     * @return boolean
     */
    locationHasPhoto () {
      return this.location.photo_url !== null && this.location.photo_name !== null
    },

    /**
     * Determine if location has no photo.
     *
     * @return boolean
     */
    locationHasNoPhoto () {
      return !this.locationHasPhoto
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/locations/helpers.js